const common = {
  home: 'Home',
  account: 'Account',
  logout: 'Logout',
  fullscreen: 'Fullscreen',
  fullscreenExit: 'Exit Fullscreen',
  cancel: 'Cancel',
  save: 'Save',
  close: 'Close',
  loading: 'Loading...',
  noData: 'No data available',
  back: 'Back',
  refresh: 'Refresh',
  time: 'Time',
};

export default common;
